/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import useStyles from "./styles";
import clsx from "clsx";
import Visibility from "@material-ui/icons/Visibility";
import ReactCodeInput from "react-code-input";

import {
	Grid,
	Button,
	TextField,
	InputAdornment,
	IconButton,
	Stepper,
	Step,
	StepButton,
	StepLabel,
	StepConnector
} from "@material-ui/core";
import { connect } from "react-redux";
import { Images } from "config/images";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

function getSteps() {
	return [0, 1, 2];
}

const VerifyPage = () => {
	const classes = useStyles();
	const history = useHistory();

	const {
		handleSubmit,
		control,
		formState: { errors }
	} = useForm();

	const [activeStep, setActiveStep] = useState(0);
	// const [completed, setCompleted] = useState({});
	// const [isPinCodeValid, setIsPinCodeValid] = useState(true);
	const [phone, setPhone] = useState("");
	const [pinCode, setPinCode] = useState("");
	// const [btnIsPressed, setBtnIsPressed] = useState(false);

	const getTitle = () => {
		switch (activeStep) {
			case 0:
				return "Xác minh tài khoản";
			case 1:
				return "Xác minh tài khoản";
			case 2:
				return "Tạo mật khẩu mới";
			default:
				return "";
		}
	};

	const getSubTitle = () => {
		switch (activeStep) {
			case 0:
				return <div>Nhập số điện thoại nhận mã OTP</div>;
			case 1:
				return (
					<div>
						Mã xác nhận OTP đã được gửi đến <br /> số điện thoại
						<span style={{ color: "#219653" }}> {phone}</span>
					</div>
				);
			case 2:
				return "";
			default:
				return "";
		}
	};

	const steps = getSteps();

	const handleNext = () => {
		const newActiveStep = activeStep + 1;
		setActiveStep(newActiveStep);
	};

	const onSubmit = data => {
		if (activeStep === 0) {
			setPhone(data.phone);
			handleNext();
		}
	};

	const handleGoToHome = () => {
		history.push("/");
	};

	const handleStep = step => () => {
		setActiveStep(step);
	};

	const handlePinChange = pinCode => {
		console.log(pinCode);
		setPinCode(pinCode);
		// setBtnIsPressed(false);
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.header }}>
				<Grid classes={{ root: classes.btnIcon }}>
					<img
						src={Images.icArrowLeftBlack}
						alt={"icArrowLeftBlack"}
					/>
				</Grid>
				<Grid
					classes={{ root: classes.btnIcon }}
					onClick={() => handleGoToHome()}
				>
					<img src={Images.icHomeActive} alt={"icHomeActive"} />
				</Grid>
			</Grid>
			<Grid style={{ padding: "5px 65px" }}>
				<img
					src={Images.logoVerify}
					alt={"logoVerify"}
					width={"100%"}
				/>
			</Grid>
			<Grid classes={{ root: classes.title }}>{getTitle()}</Grid>
			<Grid classes={{ root: classes.textVerify }}>{getSubTitle()}</Grid>
			<Grid classes={{ root: classes.rootForm }}>
				<form onSubmit={handleSubmit(onSubmit)}>
					{activeStep === 0 && (
						<Grid classes={{ root: classes.bodyPhone }}>
							<Grid>
								<Controller
									control={control}
									name="phone"
									rules={{
										required: "Vui lòng nhập số điện thoại",
										pattern: /^[0-9\-\+]{9,15}$/
									}}
									defaultValue={phone}
									render={({ field }) => (
										<TextField
											{...field}
											className={clsx(classes.inputPhone)}
											placeholder="Nhập số diện thoại"
										/>
									)}
								/>
							</Grid>
							{errors.phone && (
								<Grid classes={{ root: classes.errors }}>
									{errors.phone.type === "pattern"
										? "Vui lòng nhập đúng định dạng số điện thoại"
										: errors.phone.message}
								</Grid>
							)}
						</Grid>
					)}
					{activeStep === 1 && (
						<Grid classes={{ root: classes.opt }}>
							<ReactCodeInput
								id="pinCode"
								type="number"
								// isValid={isPinCodeValid}
								fields={4}
								onChange={handlePinChange}
								value={pinCode}
								className={classes.customReactCodeInput}
							/>
							<Grid classes={{ root: classes.resendCode }}>
								Gửi lại mã <span>(59s)</span>
							</Grid>
						</Grid>
					)}
					{activeStep === 2 && (
						<Grid style={{ padding: "10px 25px" }}>
							<Controller
								control={control}
								name="newPassword"
								rules={{
									required: "Vui lòng nhập mật khẩu mới"
								}}
								defaultValue=""
								render={({ field }) => (
									<TextField
										{...field}
										type="password"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton aria-label="toggle password visibility">
														<Visibility />
													</IconButton>
												</InputAdornment>
											)
										}}
										className={clsx(
											classes.inputPassword,
											errors?.password
												? classes.inputError
												: ""
										)}
										placeholder="Nhập mật khẩu mới"
									/>
								)}
							/>
							<Controller
								control={control}
								name="reNewPassword"
								rules={{
									required: "Vui lòng nhập lại mật khẩu mới"
								}}
								defaultValue=""
								render={({ field }) => (
									<TextField
										{...field}
										type="password"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton aria-label="toggle password visibility">
														<Visibility />
													</IconButton>
												</InputAdornment>
											)
										}}
										className={clsx(
											classes.inputPassword,
											errors?.password
												? classes.inputError
												: ""
										)}
										placeholder="Nhập lại mật khẩu"
									/>
								)}
							/>
						</Grid>
					)}
					<Grid classes={{ root: classes.bodyBtnSubmit }}>
						<Button
							type="submit"
							classes={{ root: classes.btnSubmit }}
						>
							Xác nhận
						</Button>
					</Grid>
					<Stepper
						nonLinear
						activeStep={activeStep}
						style={{ justifyContent: "center", marginTop: 55 }}
						connector={
							<StepConnector style={{ display: "none" }} />
						}
					>
						{steps.map((label, index) => (
							<Step key={label}>
								<StepButton
									onClick={handleStep(index)}
									// completed={completed[index]}
								>
									<StepLabel
										classes={{
											iconContainer: classes.iconContainer
										}}
									>
										<Grid
											style={{
												background:
													label === activeStep
														? "#EC1C24"
														: "#E9E8E8"
											}}
											classes={{ root: classes.label }}
										></Grid>
									</StepLabel>
								</StepButton>
							</Step>
						))}
					</Stepper>
					<Grid classes={{ root: classes.hotline }}>
						Hotline: <span>1900 5555</span>
					</Grid>
				</form>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		// resetFromOrderSuccess: () => {
		// 	dispatch(resetFromOrderSuccess());
		// }
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyPage);
